import Image from 'next/image';
import Icon from './amazon_white.svg?url';
import type { SvgImageProps } from '../_type';

export const AmazonWhiteImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} {...props} />;
